import { toast } from "sonner";
import api from "@/lib/api";
import { MiniPlay } from "@/components/FamilyVoices";
import { BookHeart, Music, HeartHandshake, Trash2 } from "lucide-react";

const fmt = (d) => new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export default function VoiceAlbum({ items, onChanged }) {
  const remove = async (it) => {
    if (!window.confirm("Supprimer cet enregistrement de l'album ?")) return;
    try { await api.delete(`/family/recordings/${it.id}`); onChanged(); toast.success("Supprimé de l'album"); }
    catch { toast.error("Suppression impossible."); }
  };
  return (
    <div className="rounded-3xl bg-white border border-border/60 p-6 mb-8" data-testid="family-album">
      <div className="flex items-center gap-3 mb-1"><BookHeart className="w-6 h-6 text-rose-400" /><h3 className="font-serif-display text-2xl">L'album de voix</h3></div>
      <p className="text-gray-500 mb-4">Tous les mots doux et chansons de la famille, à réécouter quand vous voulez.</p>
      {items.length === 0 ? <p className="text-gray-400 py-4 text-center">L'album se remplira avec vos premiers enregistrements.</p> : (
        <div className="grid sm:grid-cols-2 gap-3">
          {items.map((it) => {
            const Icon = it.kind === "song" ? Music : HeartHandshake;
            return (
              <div key={it.id} className={`flex items-center gap-3 rounded-2xl p-3 ${it.kind === "song" ? "bg-amber-50" : "bg-rose-50"}`} data-testid={`album-item-${it.id}`}>
                <MiniPlay url={it.audio_url} testId={`album-play-${it.id}`} />
                <span className="flex-1 min-w-0">
                  <span className="flex items-center gap-1.5 font-semibold text-gray-700 truncate">
                    <Icon className="w-4 h-4 shrink-0" /> {it.kind === "song" ? it.song_title : "Mot doux"}
                  </span>
                  <span className="block text-sm text-gray-500">{it.label} · {fmt(it.created_at)}</span>
                </span>
                {it.mine && (
                  <button onClick={() => remove(it)} className="w-9 h-9 rounded-full hover:bg-white flex items-center justify-center text-gray-400 hover:text-red-500" aria-label="Supprimer" data-testid={`album-delete-${it.id}`}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
